import { IShipmentService } from '../@posturinn/client-react';
import {
	TRACK_SHIPMENT_FAILED,
	TRACK_SHIPMENT_FULFILLED,
	TRACK_SHIPMENT_PENDING,
} from '../constants/actions/trackShipmentActions';
import { formatDate } from '../helpers/date/dateHelpers';
import { getCurrentLangPretty } from '../helpers/url/urlHelpers';

const trackShipmentPending = () => ({
	type: TRACK_SHIPMENT_PENDING,
	payload: null,
});

const trackShipmentFulfilled = (results, allTrackAndTraces) => ({
	type: TRACK_SHIPMENT_FULFILLED,
	payload: {
		results,
		allTrackAndTraces,
	},
});

const trackShipmentFailed = error => ({
	type: TRACK_SHIPMENT_FAILED,
	payload: {
		error,
	},
});

const parseTrackingEvents = trackingEvents => {
	const parsedTrackingEvents = [];

	if (trackingEvents) {
		for (let i = 0; trackingEvents[i]; i++) {
			if (trackingEvents[i].chronologicalType === 'Historic') {
				const timestamp =
					typeof trackingEvents[i].timestamp === 'string'
						? trackingEvents[i].timestamp.replace(/(?:Z|[+-]\d{2}:?\d{2})$/, '')
						: trackingEvents[i].timestamp;
				parsedTrackingEvents.push({
					date: formatDate(timestamp, 'dd.MM.yyyy'),
					time: formatDate(timestamp, 'HH:mm'),
					location: trackingEvents[i].location.name,
					description: trackingEvents[i].description,
				});
			}
		}
	}

	return parsedTrackingEvents;
};

const parseResponse = response => {
	if (response.shipment) {
		const { shipment } = response;

		return {
			trackingNumber: shipment.id,
			serviceName: shipment.labels[getCurrentLangPretty() === 'is' ? 1 : 0].title,
			custDeclNumber: shipment.customsDeclNumber,
			weight: shipment.weight ? shipment.weight + ' ' + shipment.weightUnit : null,
			error: false,
			status: {
				statusText: shipment.statusMessage,
			},
			events: parseTrackingEvents(response.trackingEvents),
			isDomestic: shipment.isDomestic,
			direction: shipment.direction,
			shipmentStatus: shipment.status,
			estimatedDeliveryDateMessage: shipment.estimatedDeliveryDateMessage,
			estimatedNumberOfDaysUntilDelivery: shipment.estimatedNumberOfDaysUntilDelivery,
			labelId: shipment.labelId,
		};
	}

	if (response.allPossibleTrackAndTraces?.length > 0) {
		const trackAndTraces = [];
		response.allPossibleTrackAndTraces.forEach(({ shipment }) => {
			trackAndTraces.push({
				trackingNumber: shipment.id,
				serviceName: shipment.labels[getCurrentLangPretty() === 'is' ? 1 : 0].title,
				custDeclNumber: shipment.customsDeclNumber,
				weight: shipment.weight ? shipment.weight + ' ' + shipment.weightUnit : null,
				error: false,
				status: {
					statusText: shipment.statusMessage,
				},
				events: parseTrackingEvents(response.trackingEvents),
				isDomestic: shipment.isDomestic,
				direction: shipment.direction,
				shipmentStatus: shipment.status,
			});
		});

		return {
			trackingNumber: null,
			error: false,
			allPossibleTrackAndTrace: trackAndTraces,
		};
	}

	return {
		error: true,
		errorDetails: {
			errorMessage: getCurrentLangPretty() === 'is' ? 'Óþekkt númer' : 'Tracking number not recognized',
		},
	};
};

export const trackShipment = (query: string) => {
	const lang = getCurrentLangPretty();

	return async (dispatch, getState) => {
		dispatch(trackShipmentPending());
		const { injector } = getState().mobizReducer;
		const shipmentService: IShipmentService = injector.get(IShipmentService);

		try {
			shipmentService.getPublicShipment(query, lang).subscribe({
				next: response => {
					const json = JSON.parse(JSON.stringify(response));
					dispatch(trackShipmentFulfilled(parseResponse(response), json.allPossibleTrackAndTraces));
				},
				error: error => {
					dispatch(trackShipmentFailed(error));
				},
			});
		} catch (error) {
			dispatch(trackShipmentFailed(error));
		}
	};
};
